import React from "react";
import { Route, Focus, Layers3 } from "lucide-react";

export default function Journey() {
    return (
        <section
            id="journey"
            data-testid="journey-section"
            className="py-20 md:py-24 bg-[color:var(--beige)]/70 border-y border-[color:var(--line)]"
        >
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <div className="font-mono-label text-[color:var(--maroon)]">
                        The Pathway
                    </div>
                    <h2
                        className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight"
                        style={{ fontWeight: 500 }}
                    >
                        How the Series Works.
                    </h2>
                    <div className="hr-gold mt-5" />
                    <p className="mt-6 text-slate-700 leading-relaxed text-base sm:text-lg max-w-2xl">
                        Each workshop focuses on one stage of the qualitative research journey. You can
                        join one workshop based on your current need, or complete the full
                        five-workshop series for step-by-step guidance from idea to publication.
                    </p>
                </div>

                <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div
                        data-testid="journey-explain-1"
                        className="rounded-2xl border border-[color:var(--line)] bg-white p-6"
                    >
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--maroon)]/8 text-[color:var(--maroon)]">
                            <Focus className="h-5 w-5" />
                        </span>
                        <div className="mt-4 font-serif text-lg text-[color:var(--navy)] leading-tight">
                            Focused per stage
                        </div>
                        <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                            Every workshop tackles one specific stage in depth, with practical templates
                            you can apply to your own study.
                        </p>
                    </div>

                    <div
                        data-testid="journey-explain-2"
                        className="rounded-2xl border border-[color:var(--line)] bg-white p-6"
                    >
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--maroon)]/8 text-[color:var(--maroon)]">
                            <Route className="h-5 w-5" />
                        </span>
                        <div className="mt-4 font-serif text-lg text-[color:var(--navy)] leading-tight">
                            Flexible entry
                        </div>
                        <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                            Join a single workshop if you need help with one stage, or bundle several
                            for deeper support across proposal, data or publication.
                        </p>
                    </div>

                    <div
                        data-testid="journey-explain-3"
                        className="rounded-2xl border border-[color:var(--line)] bg-white p-6"
                    >
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--maroon)]/8 text-[color:var(--maroon)]">
                            <Layers3 className="h-5 w-5" />
                        </span>
                        <div className="mt-4 font-serif text-lg text-[color:var(--navy)] leading-tight">
                            Complete pathway
                        </div>
                        <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                            Complete the full five-workshop series to move step by step from research
                            idea to journal publication.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
